import styled from "@emotion/styled";

export const WorkspaceContainer = styled.div`
  padding: 15px 50px 30px 50px;

  background-color: ${({ theme }) => theme.colors.background};
  min-height: calc(100vh - 104px);
  display: flex;
  flex-direction: column;
`;
